export default __webpack_public_path__ + "static/media/mapbook-general.42da669a.jpg";